class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.value = SearchForm.displayQuery(this.input.value);
      const matchMode = this.input.form.querySelector('[name="mnd_match"]');
      if (matchMode) {
        const parameters = new URLSearchParams(window.location.search);
        const requestedMode = parameters.get('mnd_match');
        const rawQuery = parameters.get('q') || '';
        const inferredMode = rawQuery && !rawQuery.includes('"') && !rawQuery.includes('variants.sku:') ? 'related' : 'exact';
        matchMode.value = requestedMode === 'related' || requestedMode === 'exact' ? requestedMode : inferredMode;
      }
      this.input.form.addEventListener('submit', this.onSearchSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  static displayQuery(value) {
    value = value.replaceAll('&quot;', '"').replaceAll('&#34;', '"');
    const exactCode = value.match(/^variants\.sku:(MND[A-Z]*-[A-Z0-9-]+) OR "\1"$/i);
    if (exactCode) return exactCode[1];
    const codeGroup = value.match(/^\(variants\.sku:(MND[A-Z]*-[A-Z0-9-]+) OR variants\.sku:\1-\*\)$/i);
    if (codeGroup) return codeGroup[1];
    if (/^variants\.sku:MND[A-Z]*-[A-Z0-9-]+$/i.test(value)) return value.slice('variants.sku:'.length);
    if (!/^"(?:[^"\\]|\\.)*"(?: AND "(?:[^"\\]|\\.)*")*$/.test(value)) return value;
    try {
      return value.match(/"(?:[^"\\]|\\.)*"/g).map(token => JSON.parse(token)).join(' ');
    } catch { return value; }
  }

  static exactQuery(value) {
    if (/^MND[A-Z]*-[A-Z0-9-]+$/i.test(value.trim())) {
      const code = value.trim().toUpperCase();
      return 'variants.sku:' + code + ' OR "' + code + '"';
    }
    return value.trim().split(/\s+/u).filter(Boolean).map(word => JSON.stringify(word)).join(' AND ');
  }

  onSearchSubmit(event) {
    if (event.defaultPrevented || !this.input.value.trim()) return;
    event.preventDefault();
    const form = this.input.form;
    const destination = new URL(form.action, window.location.origin);
    destination.search = new URLSearchParams(new FormData(form)).toString();
    const mode = destination.searchParams.get('mnd_match') || 'exact';
    destination.searchParams.set('q', mode === 'related' ? this.input.value.trim() : SearchForm.exactQuery(this.input.value));
    destination.searchParams.set('mnd_match', mode);
    if (mode === 'exact' && /^MND[A-Z]*-[A-Z0-9-]+$/i.test(this.input.value.trim())) {
      destination.searchParams.set('type', 'product');
      destination.searchParams.set('options[prefix]', 'none');
    }
    destination.searchParams.delete('page');
    window.location.assign(destination.href);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
